import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
const testimonials = [{
  quote: 'My biggest problem was structuring age-appropriate practices. Basketball Ready gave me an entire season of structure for my U13s and U15s. I spend less time planning and more time actually developing players.',
  author: 'Michael T.',
  role: 'Youth Basketball Coach'
}, {
  quote: 'The 365 Practice Library and the Season Management System completely changed how I organize our academy. This system is worth far more than the launch price.',
  author: 'James R.',
  role: 'Basketball Academy Director'
}];
export function Testimonials() {
  return <section className="relative bg-navy-900 py-12 md:py-20" data-id="element-246">
      <div className="container mx-auto px-4" data-id="element-247">
        <div className="mb-10 text-center md:mb-16" data-id="element-248">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="font-anton text-3xl uppercase tracking-wide text-white sm:text-4xl md:text-5xl" data-id="element-249">
            WHAT OTHER COACHES ARE SAYING
          </motion.h2>
        </div>

        <div className="mx-auto grid max-w-5xl grid-cols-1 gap-5 md:grid-cols-2 md:gap-8" data-id="element-250">
          {testimonials.map((testimonial, index) => <motion.article key={testimonial.author} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="relative rounded-2xl border border-navy-800 bg-navy-950 p-5 sm:p-6 md:p-8" data-id="element-251">
              <Quote className="absolute right-6 top-6 h-12 w-12 text-navy-800" data-id="element-252" />
              <div className="mb-6 flex gap-1" data-id="element-253">
                {[...Array(5)].map((_, starIndex) => <Star key={starIndex} className="h-5 w-5 fill-gold-500 text-gold-500" data-id="element-254" />)}
              </div>
              <p className="relative z-10 mb-6 text-lg italic leading-relaxed text-gray-300 sm:text-xl md:mb-8" data-id="element-255">
                &ldquo;{testimonial.quote}&rdquo;
              </p>
              <div data-id="element-256">
                <div className="font-oswald text-lg uppercase tracking-normal text-white md:text-xl md:tracking-wide" data-id="element-257">
                  {testimonial.author}
                </div>
                <div className="text-xs font-medium text-gold-500 md:text-sm" data-id="element-258">
                  {testimonial.role}
                </div>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}